export default __webpack_public_path__ + "images/0xed899bfdb28c8ad65307fa40f4acab113ae2e14c.png";